import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoCardComponent } from './components/photo-card/photo-card.component';
import { PhotoGroupComponent } from './components/photo-group/photo-group.component';
import { IndexOfPipe } from './components/pipes/photo-card.pipe';
import { LightboxModule } from 'ngx-lightbox';
import { PhotoGalleryComponent } from './components/photo-gallery/photo-gallery.component';
//import { NgxGalleryModule } from '@kolkov/ngx-gallery';

@NgModule({
	declarations: [
		PhotoCardComponent,
		PhotoGroupComponent,
		PhotoGalleryComponent,
		IndexOfPipe,
	],
	exports: [
		PhotoGroupComponent,
		PhotoCardComponent,
		PhotoGalleryComponent,
	],
	entryComponents: [
		PhotoGroupComponent,
		PhotoCardComponent,
		PhotoGalleryComponent,
	],
	imports: [
		CommonModule,
		LightboxModule
	]
})
export class PhotoReviewModule { }
